// extracted by mini-css-extract-plugin
export default {"Disclaimer":"Disclaimer_Disclaimer__HAlzB","DisclaimerContentBox":"Disclaimer_DisclaimerContentBox__4Si5a","DisclaimerLabel":"Disclaimer_DisclaimerLabel__3mF+a"};